export const LoginActionType = {
  setApplicantData: 'SET_APPLICANT_DATA'
};
